module.exports = __webpack_public_path__ + "img/image4.f85ec22a.png";